import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { GetDeepackOutboundByIdResponse, OutboundInput, SiteWithAddressResponse } from '../../../interfaces/feedstocklistmodel';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ORHaulerResponse } from '../../../interfaces/haulerModel';
import { outboundStreams } from '../../../interfaces/feedStockLoadAdditionalRevenue';
import { AlertDialogComponent } from '../../shared/components/alert-dialog/alert-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { forkJoin, of, switchMap } from 'rxjs';
import { SaveAttemptErrorMatcher } from '../../shared/commonutils/errorStateDirective';
import { formatDateOnly, numericInputLimit } from '../../shared/commonutils/helper';
import { DepackService } from '../../../services/depack.service';
import { SiteService } from '../../../services/siteservice';
import { HaulerList } from '../../../models/hauler.model';
import { HaulerService } from '../../../services/haulerservice';
import { SelectSearchComponent } from "../../shared/components/select-search/select-search.component";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSelectItems } from '../../../interfaces/lookup';
import { SaveOutboundStreamComponent } from './save-outbound-stream/save-outbound-stream.component';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { FeedstockService } from '../../../services/feedstockservice';
import { FeedstockStatus } from '../../../interfaces/feedstockstatus';
import { NotificationService } from '../../../services/notificationservice';
import html2pdf from 'html2pdf.js';
@Component({
  selector: 'app-addedit-outbound',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDialogModule,
    MatFormField,
    MatLabel,
    MatSelectModule,
    MatDatepickerModule,
    SelectSearchComponent,
    MatSelectModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatTableModule,
    DragDropModule],
  templateUrl: './addedit-outbound.component.html',
  styleUrl: './addedit-outbound.component.scss'
})
export class AddeditOutboundComponent implements OnInit, AfterViewInit {
  truckNo: string | null = null;
  bol: string | null = null;
  workOrderNo: string | null = null;
  shipFrom: MatSelectItems[] = [];
  shipFromData: SiteWithAddressResponse[] = [];
  shipToData: SiteWithAddressResponse[] = [];
  fsStatus: FeedstockStatus[] = [];
  shipFromId: string = '';
  shipFromLoc: string = "";
  shipTo: MatSelectItems[] = [];
  selectStatusItems: MatSelectItems[] = [];
  shipToId: string = "";
  carrierId: string = "";
  shipToLoc: string = "";
  locations: MatSelectItems[] = [];
  haulerList: HaulerList[] = [];
  haulers: ORHaulerResponse[] = [];
  displayValue = signal<string>('');
  driverName: string = "";
  trailerNo: string = "";
  sealNo: string = "";
  releaseNo: string = "";
  internalNotes: string = "";
  additionalStreamsDataSource = new MatTableDataSource<outboundStreams>([]);
  displayedAdditionalStreamColumns: string[] = ['actions', 'streamName', 'uOMText', "quantity",
    'cBD_WT', "cbdUOMText", 'cUST_WT', "custUOMText", "tons", "unitPrice", 'total'];
  ph: number = 0;
  poNo: string = "";
  tankerNo: string = "";
  isDataLoaded = false;
  @ViewChild('closeButton', { static: false }) closeButton!: ElementRef;
  attemptSave = signal(false);
  public matcher = new SaveAttemptErrorMatcher(() => this.attemptSave());
  bolForm: FormGroup;
  task: string = 'Add';
  screenName: string = 'Deepack';
  isDriverMode: boolean = false;
  inputType: string = "";
  workOrderNumber: string = '';
  disposalSiteId: string | null = null;
  enableControls: boolean = false;

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddeditOutboundComponent>,
    private depackService: DepackService, private dialog: MatDialog, private haulerService: HaulerService, private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public inputData: OutboundInput, private feedstockService: FeedstockService) {
    this.task = inputData.task;
    if (inputData.driverMode) {
      if (inputData.type == "Inbound") {
        this.screenName = inputData.task == 'Add' ? "Create Pickup" : 'Edit Pickup';
      } else {
        this.screenName = inputData.task == 'Add' ? "Create BOL" : 'Edit BOL';
      }
    } else {
      this.screenName = inputData.task + " " + inputData.type + " Load ";
    }
    this.isDriverMode = inputData.driverMode;
    this.inputType = inputData.type;
    this.bolForm = this.fb.group({
      shipFromId: [null, Validators.required],
      shipToId: [null, Validators.required],
      date: [new Date(), Validators.required],
      bol: [{ value: '', disabled: true }],
      workOrderNo: [{ value: '', disabled: true }],
      carrierId: [null, Validators.required],
      driver: [''],
      truckNo: [''],
      trailerNo: [''],
      tankerNo: [''],
      purchaseOrderNo: [''],
      sealNo: [''],
      releaseNo: [''],
      cbdPh: [''],
      internalNotes: [''],
      locationId: [null],
      status: [{ value: this.inputData.driverMode ? 9 : 1, disabled: this.inputData.driverMode === true }],
      items: this.fb.array([])
    });

    const isInboundDriverMode = this.inputData.driverMode === true && this.inputData.type === 'Inbound';
    const locationCtrl = this.bolForm.get('locationId');
    if (isInboundDriverMode) {
      locationCtrl?.setValidators([Validators.required]);
    } else {
      locationCtrl?.clearValidators();
    }
    locationCtrl?.updateValueAndValidity();

  }

  ngOnInit(): void {
    this.loadAllDropdownData();
  }

  loadAllDropdownData(): void {
    this.isDataLoaded = false;

    const isInboundDriverMode = this.inputData.driverMode === true && this.inputData.type === 'Inbound';

    forkJoin({
      shipFromSites: this.depackService.getShipFrom(),
      shipToSites: this.depackService.getShipTo(),
      haulers: this.haulerService.getHaulerList(),
      statues: this.feedstockService.getFeedStockStatuses(''),
      inboundShipTo: this.depackService.getDisposalSites()
    })
    .pipe(
      switchMap(({ shipFromSites, shipToSites, haulers, statues, inboundShipTo }) => {       
        console.log("ship to inbound", inboundShipTo); 
        this.haulerList = haulers;
        this.fsStatus = statues;
        this.selectStatusItems = this.fsStatus.map(item => ({
          id: item.id,
          name: item.description!
        }));
  
        if (isInboundDriverMode) {
          this.shipToData = inboundShipTo;
          this.shipTo = inboundShipTo.map(x => ({
            id: x.id,
            name: x.siteName ?? ''
          }));
          var defaultid = this.shipTo.find(i => i.name === 'Dade City ORA')?.id;  
          const selectedShipToId =
            this.inputData.task === 'Edit' && this.inputData.ipData
              ? Number(this.inputData.ipData.shipTo?.replace('VRS-', ''))
              : defaultid;
              
          this.bolForm.patchValue({ shipToId: selectedShipToId });
          this.shipToId = selectedShipToId.toString();
          this.shipToLoc = inboundShipTo.find(x => x.id === selectedShipToId)?.address ?? '';
  
          return this.depackService.getCustomersBySite(selectedShipToId.toString());
        }
  
        // Driver Outbound + Non Driver: normal flow
        this.shipFromData = shipFromSites;
        this.shipFrom = shipFromSites.map(x => ({
          id: x.id,
          name: x.siteName ?? ''
        }));

          this.shipToData = shipToSites;
          this.shipTo = shipToSites.map(x => ({
            id: x.id,
            name: x.siteName ?? ''
          }));

          return of(null);
        })
      )
      .subscribe({
        next: (customers) => {
          if (customers) {
            this.shipFromData = customers as any;
            this.shipFrom = customers.map((item: any) => ({
              id: item.id,
              name: item.name ?? item.siteName ?? ''
            }));
          }

          this.loadEditData();
          this.isDataLoaded = true;
        }
      });
  }

  loadEditData(): void {
    if (this.inputData.task === 'Add' || !this.inputData.ipData) {
      return;
    }
    const row = this.inputData.ipData;
    console.log("edit data", row);
    if (row.id && row.id > 0) {      
      this.depackService.getDepackOutboundById(row.id).subscribe({
        next: (rowData: GetDeepackOutboundByIdResponse) => {
          console.log("edit data", rowData);
          this.workOrderNumber = rowData.workOrderNumber;
          const shipFromId = Number(rowData.shipFrom);
          const shipToId = Number(rowData.shipTo?.replace('VRS-', ''));
          const selectedStatus = this.fsStatus.find( x => x.description?.trim().toLowerCase() === rowData.status?.trim().toLowerCase())
          const selectedHauler = this.haulerList.find(
            (x: any) =>
              x.name?.trim().toLowerCase() === rowData.carrierName?.trim().toLowerCase()
          );
          const carrierId = selectedHauler?.id ?? null;
          const statusId = selectedStatus?.id ?? null;
          this.bolForm.patchValue({
            shipFromId: shipFromId,
            shipToId: shipToId,
            date: rowData.date ? new Date(rowData.date) : null,
            bol: rowData.bol,
            workOrderNo: rowData.workOrderNumber,
            carrierId: carrierId,
            driver: rowData.driver,
            truckNo: rowData.truckNo,
            trailerNo: rowData.trailerNo,
            tankerNo: rowData.tankerNo,
            purchaseOrderNo: rowData.purchaseOrderNo,
            sealNo: rowData.seal,
            releaseNo: rowData.release,
            cbdPh: row.cbD_PH,
            internalNotes: rowData.notes,
            status: statusId
          });
        
          this.shipFromId = shipFromId.toString();
          this.shipToId = shipToId.toString();
          this.carrierId = carrierId?.toString() ?? '';
        
          this.shipFromLoc = this.shipFromData.find(i => i.id == shipFromId)?.address ?? "";
          this.shipToLoc = this.shipToData.find(i => i.id == shipToId)?.address ?? "";
        
          if (this.shipFromId && this.inputType?.trim().toLowerCase() === 'inbound') {
            this.onCustomerChangeEdit(shipFromId, rowData.location ?? '');
          }
        }
      });
      this.depackService.getdepackOutboundGridById(row.id).subscribe({
        next: (streams: any[]) => {
          console.log("outbound streams", streams);
          this.additionalStreamsDataSource.data = (streams ?? []).map(x => ({
            id: this.task === 'Edit' ? x.id : 0,
            fSLoadID: this.task === 'Edit' ? x.fsLoadID : 0,
            streamID: x.streamID,
            streamName: x.streamName,
            task: '',
            isRevenue: x.isRevenue,
            uom: x.uom,
            uOMText: x.uomName,
            quantity: x.quantity,

            cBD_WT: x.cbD_WT,
            cBD_UOM: x.cbD_UOM,
            cbdUOMText: x.cbdUomName,

            cUST_WT: x.cusT_WT,
            cUST_UOM: x.cusT_UOM,
            custUOMText: x.custUomName,

            tons: x.tons,
            unitPrice: x.unitPrice,

            total: ((x.cusT_WT ?? 0) * (x.unitPrice ?? 0))
          }));
        }
      });
    }
    this.workOrderNumber = row.workOrderNumber;
    const shipFromId = Number(row.shipFrom);
    const shipToId = Number(row.shipTo?.replace('VRS-', ''));
    const selectedStatus = this.fsStatus.find(x => x.description?.trim().toLowerCase() === row.status?.trim().toLowerCase())
    const selectedHauler = this.haulerList.find(
      (x: any) =>
        x.name?.trim().toLowerCase() === row.carrierName?.trim().toLowerCase()
    );
    const carrierId = selectedHauler?.id ?? null;
    const statusId = selectedStatus?.id ?? null;
    this.bolForm.patchValue({
      shipFromId: shipFromId,
      shipToId: shipToId,
      date: row.date ? new Date(row.date) : null,
      bol: row.bol,
      workOrderNo: row.workOrderNumber,
      carrierId: carrierId,
      driver: row.driver,
      truckNo: row.truckNo,
      trailerNo: row.trailerNo,
      tankerNo: row.tankerNo,
      purchaseOrderNo: row.purchaseOrderNo,
      sealNo: row.seal,
      releaseNo: row.release,
      cbdPh: row.cbD_PH,
      internalNotes: row.notes,
      status: statusId
    });

    this.shipFromId = shipFromId.toString();
    this.shipToId = shipToId.toString();
    this.carrierId = carrierId?.toString() ?? '';

    this.shipFromLoc = this.shipFromData.find(i => i.id == shipFromId)?.address ?? "";
    this.shipToLoc = this.shipToData.find(i => i.id == shipToId)?.address ?? "";

    if (this.shipFromId && this.inputType?.trim().toLowerCase() === 'inbound') {
      this.onCustomerChange(shipFromId);
    }
  }

  onStatusreceived(statId: number| null){
    //console.log(statId);
    this.bolForm.patchValue({
      status: statId
    });
  
    this.bolForm.get('status')?.updateValueAndValidity();
  }

  //save(): void {
  //  console.log("Save triggered");
  //  this.attemptSave.set(true);
  //  this.bolForm.markAsDirty();
  //  this.bolForm.markAllAsTouched();
  //  if (this.bolForm.invalid) {
  //    return;
  //  }
  //  if (this.inputType === 'Outbound' && this.additionalStreamsDataSource.data.length === 0) {
  //    this.dialog.open(AlertDialogComponent, {
  //      data: {
  //        title: 'Alert',
  //        message: 'Please add at least one line item.'
  //      },
  //      disableClose: true,
  //      panelClass: 'delete-confirmation-dialog-nowrap'
  //    });
  //    return;
  //  }else{
  //    const streams = this.additionalStreamsDataSource.data;
  //    const hasRevenue = streams.some(x => x.isRevenue === true);
  //    const hasNonRevenue = streams.some(x => x.isRevenue === false);

  //    if (hasRevenue && hasNonRevenue) {
  //      this.dialog.open(AlertDialogComponent, {
  //        data: {
  //          title: 'Alert',
  //          message: `All materials on this load must be of either Revenue or Expense type.`
  //        },
  //        disableClose: true,
  //        panelClass: 'delete-confirmation-dialog-nowrap'
  //      });
  //      return;
  //    }
  //  }

  //  const formValue = this.bolForm.getRawValue();

  //  const payload = {
  //    id: this.inputData.ipData?.id ?? null,
  //    shipFrom: formValue.shipFromId?.toString(),
  //    shipTo: 'VRS-'+formValue.shipToId?.toString(),
  //    date: formatDateOnly(formValue.date),
  //    bol: formValue.bol,
  //    workOrderNumber: formValue.workOrderNo,
  //    carrierName: 'MH-'+formValue.carrierId?.toString(),
  //    driver: formValue.driver,
  //    truckNo: formValue.truckNo,
  //    trailerNo: formValue.trailerNo,
  //    tankerNo: formValue.tankerNo,
  //    purchaseOrderNo: formValue.purchaseOrderNo,
  //    seal: formValue.sealNo,
  //    release: formValue.releaseNo,
  //    cbD_PH: formValue.cbdPh,
  //    notes: formValue.internalNotes,
  //    status: formValue.status,
  //    direction: this.inputType === 'Outbound',
  //    streams: this.additionalStreamsDataSource.data
  //  };

  //  console.log('BOL Saved', payload);
  //  this.depackService.saveDeepackOutbound(payload).subscribe({
  //    next: (id) => {
  //      console.log('Saved successfully', id);
  //      this.dialogRef.close(true);
  //    }
  //  });
  //}
  save(isPrint: boolean = false): void {

    console.log("Save triggered");

    this.attemptSave.set(true);
    this.bolForm.markAsDirty();
    this.bolForm.markAllAsTouched();

    // Form validations
    if (this.bolForm.invalid) {
      return;
    }

    // Additional stream validations
    if (
      this.inputType === 'Outbound' &&
      this.additionalStreamsDataSource.data.length === 0
    ) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'Please add at least one line item.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });

      return;
    } else {

      const streams = this.additionalStreamsDataSource.data;

      const hasRevenue = streams.some(x => x.isRevenue === true);
      const hasNonRevenue = streams.some(x => x.isRevenue === false);

      if (hasRevenue && hasNonRevenue) {

        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Alert',
            message:
              'All materials on this load must be of either Revenue or Expense type.'
          },
          disableClose: true,
          panelClass: 'delete-confirmation-dialog-nowrap'
        });

        return;
      }
    }

    const formValue = this.bolForm.getRawValue();

    const payload = {
      id: this.task === 'Edit' ? this.inputData.ipData?.id ?? null : null,
      shipFrom: formValue.shipFromId?.toString(),
      shipTo: 'VRS-' + formValue.shipToId?.toString(),
      date: formatDateOnly(formValue.date),
      bol: this.task === 'Edit' ? formValue.bol : null,
      workOrderNumber: this.task === 'Edit' ? formValue.workOrderNo : null,
      carrierName: 'MH-' + formValue.carrierId?.toString(),
      driver: formValue.driver,
      truckNo: formValue.truckNo,
      trailerNo: formValue.trailerNo,
      tankerNo: formValue.tankerNo,
      purchaseOrderNo: formValue.purchaseOrderNo,
      seal: formValue.sealNo,
      release: formValue.releaseNo,
      cbD_PH: formValue.cbdPh === '' || formValue.cbdPh == null
      ? null
      : Number(formValue.cbdPh),
      notes: formValue.internalNotes,
      status: formValue.status,
      direction: this.inputType === 'Outbound',
      streams: this.additionalStreamsDataSource.data
    };

    console.log('BOL Saved', payload);

    this.depackService.saveDeepackOutbound(payload).subscribe({
      next: async (response: any) => {
        this.notificationService.show(`Data saved successfully`, 'Success');
        //this.bolForm.patchValue({
        //  bol: response.billOfLandingNo
        //});
        //// Optional
        //this.workOrderNumber = response.workOrderNumber;
        const loadScheduleId = response.id;
        const bolNumber = response.billOfLandingNo;
        if (isPrint) {
          await this.print(loadScheduleId, bolNumber);
        }

        this.dialogRef.close(true);
      }
    });
  }

  saveandprint(): void {
    this.save(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      try {
        if (this.closeButton) {
          this.closeButton.nativeElement.blur();
        }
      } catch (error) { }
    }, 0);
  }

  onKeydown(event: KeyboardEvent) {
    if (event.ctrlKey && event.metaKey) { return; }
    if (!/[0-9\/]/.test(event.key) && event.key.length === 1) {
      event.preventDefault();
    }
  }

  dateformat(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if (!value) return;
    const parts = value.split('/');
    if (parts.length !== 3) return;

    let [month, day, year] = parts.map(part => part.padStart(2, '0'));
    if (month.length === 1) month = '0' + month;
    if (day.length === 1) day = '0' + day;
    if (year.length === 2) year = '20' + year;
    input.value = `${month}/${day}/${year}`;
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, type: number): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;

    val = val = numericInputLimit(event, maxValue, maxDecimals);

    this.displayValue.set(val);
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.';
    const parsedValue = maxDecimals === 0 ? parseInt(val, 10) : parseFloat(val);
    const finalValue = isValueEmpty ? null : parsedValue;
    switch (type) {
      case 1: this.ph = finalValue ?? 0; break;
    }
  }

  onShipFromReceived(event: number | null) {
    this.shipFromId = event?.toString() ?? '';
    this.shipFromLoc = this.shipFromData.find(i => i.id == parseInt(this.shipFromId))?.address ?? "";

    if (this.shipFromId !== '') {
      this.onCustomerChange(parseInt(this.shipFromId));
    }
  }

  onShipToReceived(event: number | null) {
    this.shipToId = event?.toString() ?? '';
    this.shipToLoc = this.shipToData.find(i => i.id == parseInt(this.shipToId))?.address ?? "";

    const isDriverInbound = this.inputData.driverMode === true && this.inputData.type === 'Inbound';

    if (isDriverInbound && this.shipToId) {
      this.depackService.getCustomersBySite(this.shipToId).subscribe({
        next: (response) => {
          this.shipFromData = response as any;
          this.shipFrom = response.map((x: any) => ({
            id: x.id,
            name: x.name ?? x.siteName ?? ''
          }));

          this.bolForm.patchValue({ shipFromId: null });
          this.shipFromId = '';
          this.shipFromLoc = '';
        }
      });
    }
  }

  onCarrierReceived(event: number | null) {
    this.carrierId = event?.toString() ?? '';
  }

  onCustomerChange(customerId: number) {
    this.depackService.getCustomerLocations(customerId).subscribe({
      next: (response) => {
        this.locations = [];
        response.forEach(item => {
          this.locations.push({ id: item.id ?? 0, name: item.name ?? '' });
        })
      }
    });
  }
  
  onCustomerChangeEdit(customerId: number, location: string) {
    this.depackService.getCustomerLocations(customerId).subscribe({
      next: (response) => {
        this.locations = [];
        response.forEach(item => {
          this.locations.push({id: item.id ?? 0 , name: item.name ?? ''});
        })
        if(location !== ''){
          var locId = response.find(i => i.name.trim().toLowerCase() === location.trim().toLowerCase())?.id
          if(locId != null || locId != undefined){
            this.bolForm.get('locationId')?.setValue(locId);
          }
        }
      }
    });
  }

  openAddStreamPopup(task: string, row: outboundStreams | null): void {
    if(this.shipFromId === ''){
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'ALert',
          message: 'Please select Ship From before adding a Stream.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    const statusId = this.bolForm.get('status')?.value;
    const dialogRef = this.dialog.open(SaveOutboundStreamComponent, {
      width: '700px',
      maxWidth: '700px',
      disableClose: true,
      data: {
        customerId: this.shipFromId,
        driverMode: this.inputData.driverMode,
        existingStreams: this.additionalStreamsDataSource.data,
        task: task,
        editData: row,
        statusId: statusId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      const data = [...this.additionalStreamsDataSource.data];
      if (task === 'Edit') {
        const index = data.findIndex(x =>
          x.id && result.id
            ? x.id === result.id
            : x.tempKey === result.tempKey
        );

        if (index > -1) {
          data[index] = result;
        } else {
          data.push(result);
        }
      } else {
        result.tempKey = Date.now();
        data.push(result);
      }

      this.additionalStreamsDataSource.data = data;
    });
  }

  getGrandTotal(): number {
    return this.additionalStreamsDataSource.data.reduce(
      (sum, row) => sum + Number(row.total ?? 0),
      0
    );
  }

  async print(loadScheduleId: number | null,
    bolNumber: string | null): Promise<void> {

    // Get form values
    const formData = this.bolForm.getRawValue();

    // Load HTML template
    const response = await fetch('assets/templates/BOL-TEMPLATE.html');

    let html = await response.text();
    html = html.replace(
      '{{ShipFromSiteName}}',
      this.shipFrom?.find(
        (x: any) => x.id === formData.shipFromId
      )?.name || ''
    );

    const selectedShipFrom = this.shipFrom?.find(
      (x: any) => x.id === formData.shipFromId
    );

    let shipFromLine1 = '';
    let shipFromLine2 = this.shipFromLoc || '';

    if (selectedShipFrom?.name === 'Dade City ORA') {

      shipFromLine1 = 'Complete Beverage Destruction LLC';
    }

    html = html.replace('{{ShipFrom}}', shipFromLine1);
    html = html.replace('{{ShipFrom2}}', shipFromLine2);
    // Replace placeholders
    html = html.replaceAll('{{BolNumber}}', bolNumber || '');
    html = html.replace(
      '{{Status}}',
      this.selectStatusItems?.find(
        (x: any) => x.id === formData.status
      )?.name || ''
    );
    html = html.replace(
      '{{Carrier}}',
      this.haulerList?.find(
        (x: any) => x.id === formData.carrierId
      )?.name || ''
    );

    html = html.replace('{{TruckNo}}', formData.truckNo || '');
    html = html.replace('{{TrailerNo}}', formData.trailerNo || '');
    html = html.replace('{{TankerNo}}', formData.tankerNo || '');
    html = html.replace('{{SealNo}}', formData.sealNo || '');
    html = html.replace('{{ReleaseNo}}', formData.releaseNo || '');
    html = html.replace('{{DriverName}}', formData.driver || '');
    html = html.replace('{{CustomerRef}}', formData.purchaseOrderNo || '');

    // Date
    html = html.replace(
      '{{Date}}',
      formData.date
        ? new Date(formData.date).toLocaleDateString()
        : ''
    );

    // Ship From / Ship To
    html = html.replace('{{ShipTo}}', this.shipToLoc || '');
    html = html.replace(
      '{{ShipToDisposalSite}}',
      this.shipTo?.find(
        (x: any) => x.id === formData.shipToId
      )?.name || ''
    );

    // Additional Streams
    const streamRows = this.additionalStreamsDataSource.data || [];

    let additionalStreamsHtml = `
  <table class="items-table">
    <thead>
      <tr>
        <th>Stream Name</th>
        <th>Qty</th>
        <th>Qty UOM</th>
        <th>Site WT</th>
        <th>Site UOM</th>
        <th>Cust WT</th>
        <th>Cust UOM</th>
      </tr>
    </thead>
    <tbody>
  `;

    streamRows.forEach((x: any) => {

      additionalStreamsHtml += `
      <tr>
        <td>${x.streamName || ''}</td>
        <td>${x.quantity || ''}</td>
        <td>${x.uOMText || ''}</td>
        <td>${x.cBD_WT || ''}</td>
        <td>${x.cbdUOMText || ''}</td>
        <td>${x.cUST_WT || ''}</td>
        <td>${x.custUOMText || ''}</td>
      </tr>
    `;
    });

    additionalStreamsHtml += `
    </tbody>
  </table>
  `;

    html = html.replace(
      '<div id="additionalStreamsDataSource"  class="items-table"></div>',
      additionalStreamsHtml
    );

    // Create temp element
    const element = document.createElement('div');

    element.innerHTML = html;

    document.body.appendChild(element);

    // PDF options
    const options = {
      margin: 5,
      filename: `BOL-${formData.bol || 'Document'}.pdf`,
      image: {
        type: 'jpeg' as const,
        quality: 1
      },
      html2canvas: {
        scale: 2,
        useCORS: true
      },
      jsPDF: {
        unit: 'mm' as const,
        format: 'a4' as const,
        orientation: 'portrait' as const
      }
    };

    // Generate PDF Blob
    const pdfBlob = await (html2pdf as any)()
      .set(options)
      .from(element)
      .outputPdf('blob');

    // =========================================================
    // SAVE PDF INTO DATABASE
    // =========================================================

    const pdfFile = new File(
      [pdfBlob],
      `BOL-${formData.bol || 'Document'}.pdf`,
      {
        type: 'application/pdf'
      }
    );

    const uploadFormData = new FormData();

    uploadFormData.append('files', pdfFile);
    uploadFormData.append(
      'loadScheduleId', loadScheduleId?.toString() ?? '0'
    );

    uploadFormData.append(
      'screenTypeId',
      '5'
    );

    uploadFormData.append(
      'docTypeId',
      '11'
    );

    this.feedstockService
      .uploadLoadDocument(uploadFormData)
      .subscribe({
        next: () => {
          console.log('PDF uploaded successfully');
        },
        error: (err) => {
          console.error('PDF upload failed', err);
        }
      });

    // =========================================================
    // OPEN PDF IN NEW TAB
    // =========================================================

    const pdfUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfUrl, '_blank');

    // =========================================================
    // OPEN PRINT WINDOW
    // =========================================================

    const printWindow = window.open('', '_blank');

    if (printWindow) {

      printWindow.document.write(`
      <html>
        <head>
          <title>Print PDF</title>

          <style>
            body {
              margin: 0;
              padding: 20px;
              font-family: Arial, sans-serif;
            }

            .print-btn {
              padding: 10px 20px;
              font-size: 16px;
              cursor: pointer;
              margin-bottom: 20px;
            }

            iframe {
              width: 100%;
              height: 90vh;
              border: 1px solid #ccc;
            }
          </style>
        </head>

        <body>

          <button class="print-btn" onclick="window.print()">
            Print PDF
          </button>

          <iframe src="${pdfUrl}"></iframe>

        </body>
      </html>
    `);

      printWindow.document.close();
    }

    // Cleanup
    setTimeout(() => {
      URL.revokeObjectURL(pdfUrl);
      document.body.removeChild(element);
    }, 10000);
  }

  deleteAddtStreams(row: outboundStreams) {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Additional Stream ${row.streamName}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true,
    }).afterClosed().subscribe(result => {
      if (result) {
        if (!row.id || row.id === 0) {

          this.additionalStreamsDataSource.data =
            this.additionalStreamsDataSource.data.filter(x =>
              x.tempKey
                ? x.tempKey !== row.tempKey
                : x !== row
            );

          return;
        }
        if (row.id !== null && row.id !== undefined) {
          this.additionalStreamsDataSource.data = this.additionalStreamsDataSource.data.filter(item => item.id !== row.id);
          if (row.id > 0) {
            this.feedstockService.deleteFSLoadAdditionalStreamsById(row.id).subscribe({
              next: async (response) => {
                console.log("Additional Stream deleted successfully", response);
              }
            });
          }
        }
      }
    });
  }
}
